var React = require('react');

function CheckIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("desc",{"key":1},"Generated with Avocode."),React.createElement("g",{"key":2},React.createElement("g",null,[React.createElement("title",{"key":0},"Pfad 40"),React.createElement("path",{"d":"M4,16.72961v0l6.56787,6.56787v0l18.59473,-18.59485v0","fillOpacity":"0","fill":"#ffffff","strokeDashoffset":"0","strokeLinejoin":"round","strokeLinecap":"round","strokeOpacity":"1","stroke":"#2a2c2b","strokeMiterlimit":"20","strokeWidth":"7","key":1})]))]);
}

CheckIcon.defaultProps = {"id":"SVGDoc","width":"34","height":"28","version":"1.1","xmlnsAvocode":"https://avocode.com/","viewBox":"0 0 34 28"};

module.exports = CheckIcon;

CheckIcon.default = CheckIcon;
